import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { NoConnectionNotification } from 'cpnl-common';
import { fetchNoConnectionNotification } from './NoConnectionNotificationSlice';
import { NoConnectionNotificationSelector } from './NoConnectionNotificationSelector';

export function useNoConnectionNotification(): AbstractContentState<NoConnectionNotification> {
    return useCmsContent(fetchNoConnectionNotification, NoConnectionNotificationSelector);
}
